import { useEffect, useState } from "react";
import { isWeb, useEvent } from "tamagui";
function useIsIntersecting(refs, { once, ...opts } = {}) {
  const [values, setValues] = useState([]);
  if (isWeb) {
    useOnIntersecting(
      refs,
      (entries) => {
        const intersecting = entries.some((x) => x == null ? void 0 : x.isIntersecting);
        if (once && !intersecting)
          return;
        setValues((prev) => {
          const next = entries.map((e) => (e == null ? void 0 : e.isIntersecting) ?? false);
          if (prev.length === next.length && prev.every((e, i) => e === next[i])) {
            return prev;
          }
          return next;
        });
      },
      opts
    );
  }
  return Array.isArray(refs) ? values : values[0];
}
function useOnIntersecting(refsIn, incomingCbRaw, { threshold = 0, root, rootMargin } = {}, mountArgs = []) {
  const onIntersectEvent = useEvent(incomingCbRaw);
  useEffect(() => {
    const refs = Array.isArray(refsIn) ? refsIn : [refsIn];
    if (!refs.length)
      return;
    let dispose = null;
    let currentEntries = [];
    const options = {
      threshold,
      root,
      rootMargin
    };
    const io = new IntersectionObserver((entries) => {
      currentEntries = refs.map((ref, index) => {
        return entries.find((x) => x.target === ref.current) ?? currentEntries[index] ?? null;
      });
      dispose == null ? void 0 : dispose();
      dispose = onIntersectEvent(currentEntries) || null;
    }, options);
    for (const ref of refs) {
      if (ref.current) {
        io.observe(ref.current);
      }
    }
    return () => {
      dispose == null ? void 0 : dispose();
      io.disconnect();
    };
  }, [
    onIntersectEvent,
    refsIn,
    root,
    rootMargin,
    threshold,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ...mountArgs
  ]);
}
export {
  useIsIntersecting,
  useOnIntersecting
};
//# sourceMappingURL=useOnIntersecting.js.map
